export const physicalHazardsOptions = [
  'Severe Weather',
  'On-Water Response',
  'Flooding',
  'Heat',
  'Ice / Winter Conditions',
  'Debris in Water',
];

export const environmentalHazardsOptions = [
  'Oil / Petroleum Products',
  'Flammable Gas',
  'Radiological',
  'Poison / Toxins',
  'Blood-Borne Pathogens',
  'Biological Diseases',
  'Hazardous Materials',
  'Explosives',
  'Human Remains',
  'Nuclear',
  'Fire',
];

export const otherHazardsOptions = [
  'Terrorism',
  'Civil Disturbance',
  'Traumatic Incident Stress',
  'Criminal Violence',
  'Wildlife Encounters',
];

export const ppeOptions = [
  'Life Jackets',
  'Gloves',
  'Respirators',
  'Steel-Toed Boots',
  'Masks',
  'Face Shields',
  'Hard Hat',
  'Hearing Protection',
  'Fall-Protection Gear',
  'Eye Protection',
  'Protective Clothing',
  'Gas Detectors',
];
